import { useQuery } from '@tanstack/react-query';
import { getUserNotificationsCommunication } from '../services/notificationServices';

export const useGetUserNotifications = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['userNotifications', userId],
    queryFn: () => getUserNotificationsCommunication(userId),
  });
};
